module.exports = __webpack_public_path__ + "img/instructions.7eeda842.jpg";